import { langFromPathname, pathnameWithoutLang } from '../../utils';
const defaultLangChange = (lang, etLangPath, ruLangPath) => {
    if (window.onLangChange) {
        window.onLangChange(lang);
        return;
    }
    if (lang === 'et' && etLangPath) {
        window.location.assign(etLangPath);
        return;
    }
    if (lang === 'ru' && ruLangPath) {
        window.location.assign(ruLangPath);
        return;
    }
    window.location.assign(`/${lang}${pathnameWithoutLang(window.location.pathname)}${window.location.search}`);
};
const shopLangChange = (lang, etLangPath, ruLangPath) => {
    if (lang === 'et' && etLangPath) {
        window.location.assign(etLangPath);
        return;
    }
    if (lang === 'ru' && ruLangPath) {
        window.location.assign(ruLangPath);
        return;
    }
    window.location.assign(`?lang=${lang}`);
};
export const resolveLang = (lang, path) => {
    return lang || langFromPathname(path) || 'et';
};
export const resolveLangChange = (app) => {
    switch (app) {
        case 'shop':
            return shopLangChange;
        default:
            return defaultLangChange;
    }
};
//# sourceMappingURL=LanguageUtil.js.map